import { render, staticRenderFns } from "./ayuda_admin.vue?vue&type=template&id=2043b8da&scoped=true"
import script from "./ayuda_admin.vue?vue&type=script&lang=js"
export * from "./ayuda_admin.vue?vue&type=script&lang=js"
import style0 from "./ayuda_admin.vue?vue&type=style&index=0&id=2043b8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2043b8da",
  null
  
)

export default component.exports